import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "form-header" }, "Create your new OTC Pro account", -1)
const _hoisted_3 = { class: "row mt-3" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3 d-flex justify-content-center"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "need-account-link" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Sign In Now")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h1", null, "Check your email!", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" We've sent an activation link to ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "Go click it to activate your trial and download OTC Pro!", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "If you don't see the email please check your spam folder.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_modal = _resolveComponent("loading-modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_recaptcha_block = _resolveComponent("recaptcha-block")!
  const _component_status_block = _resolveComponent("status-block")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_form_container = _resolveComponent("login-form-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_modal, { enabled: _ctx.loadingShow }, null, 8, ["enabled"]),
    _createVNode(_component_login_form_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Form, { onSubmit: _ctx.signUp }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "FirstName",
                    class: "form-control",
                    placeholder: "First Name",
                    modelValue: _ctx.signupData.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signupData.firstName) = $event)),
                    rules: "required",
                    disabled: _ctx.showActivationSuccess
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ErrorMessage, {
                    class: "error-message",
                    name: "FirstName"
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "LastName",
                    class: "form-control",
                    placeholder: "Last Name",
                    modelValue: _ctx.signupData.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signupData.lastName) = $event)),
                    rules: "required",
                    disabled: _ctx.showActivationSuccess
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_ErrorMessage, {
                    class: "error-message",
                    name: "LastName"
                  })
                ])
              ]),
              _createVNode(_component_Field, {
                type: "email",
                name: "Email",
                class: "form-control mt-3",
                placeholder: "Email",
                modelValue: _ctx.signupData.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signupData.email) = $event)),
                rules: "required|email",
                disabled: _ctx.showActivationSuccess
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_ErrorMessage, {
                class: "error-message",
                name: "Email"
              }),
              _createVNode(_component_Field, {
                type: "password",
                name: "Password",
                class: "form-control mt-3",
                placeholder: "Password",
                modelValue: _ctx.signupData.password,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signupData.password) = $event)),
                rules: "required|password",
                disabled: _ctx.showActivationSuccess
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_ErrorMessage, {
                class: "error-message",
                name: "Password"
              }),
              _createVNode(_component_Field, {
                type: "password",
                name: "PasswordConfirm",
                class: "form-control mt-3",
                placeholder: "Confirm Password",
                modelValue: _ctx.signupData.confirmPassword,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signupData.confirmPassword) = $event)),
                rules: "required|confirmed:Password",
                disabled: _ctx.showActivationSuccess
              }, null, 8, ["modelValue", "disabled"]),
              _createVNode(_component_ErrorMessage, {
                class: "error-message",
                name: "PasswordConfirm"
              }),
              (_ctx.captchaEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_recaptcha_block, { ref: "recaptcha" }, null, 512)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn-submit w-100 mt-4",
                disabled: _ctx.showActivationSuccess
              }, "Create My Account", 8, _hoisted_7),
              _createVNode(_component_status_block, {
                message: _ctx.errorMessage,
                class: "mt-3"
              }, null, 8, ["message"])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_router_link, {
            to: "/login",
            class: "signup-now-link"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        (_ctx.showActivationSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("b", null, _toDisplayString(_ctx.emailSent), 1),
                _hoisted_14
              ]),
              _hoisted_15,
              _hoisted_16
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}